import type { FC } from "react";

import Header from "app/pages/industry-analysis/overview/widgets/key-indicators/single/common/Header";
import { SWReactTable } from "app/components/React/Table/SWReactTable";
import {
    DomainsTableWrapper,
    WidgetWrapper,
} from "app/components/React/TopSites/DomainsTable/TopPlayersTableOverview/PlayersTableWidget.styles";
import { translate } from "app/filters/i18nFilter";
import { IndustryOverviewLoader } from "app/pages/industry-analysis/overview/components/common/IndustryOverviewLoader/IndustryOverviewLoader";

export interface IPlayersTableWidget {
    tableConfig: any;
    date: string;
    widgetTitle: string;
    formattedTableData: any;
    isBeta?: boolean;
    widgetTooltip: string;
    dataAutomationAttribute: string;
    isLoading?: boolean;
    loaderRowsNumber?: number;
    showFromOnHeader?: boolean;
}

export const PlayersTableWidget: FC<IPlayersTableWidget> = ({
    tableConfig,
    date,
    widgetTitle,
    formattedTableData,
    isBeta = false,
    widgetTooltip,
    dataAutomationAttribute,
    loaderRowsNumber,
    isLoading = false,
    showFromOnHeader = false,
}) => {
    const tableContent = () => {
        if (!formattedTableData) {
            return <IndustryOverviewLoader />;
        }
        return (
            <SWReactTable
                tableColumns={tableConfig.columns}
                tableOptions={tableConfig.options}
                tableData={formattedTableData}
                tableHeight={20}
                isLoading={isLoading}
                loaderRowsNumber={loaderRowsNumber}
            />
        );
    };

    return (
        <WidgetWrapper data-automation={dataAutomationAttribute}>
            <Header
                title={translate(widgetTitle)}
                tooltip={translate(widgetTooltip)}
                isLoading={isLoading}
                showFrom={showFromOnHeader}
            />
            <DomainsTableWrapper>{tableContent()}</DomainsTableWrapper>
        </WidgetWrapper>
    );
};
